import Repository from './Repository'

const resource = '/v1/setting'

export default {
    get () {
        return new Promise((resolve, reject) => {
            Repository.get(`${resource}`)
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
    create (payload) {
        return new Promise((resolve, reject) => {
            Repository.post(`${resource}`, payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
    deleteItem (payload) {
        return new Promise((resolve, reject) => {
            Repository.delete(`${resource}/${payload}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
    updateItem (payload, id) {
        return new Promise((resolve, reject) => {
            Repository.patch(`${resource}/${id}`, payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
}
